module.exports = __webpack_public_path__ + "images/header-harmonie-muenchen-impressum-f35951d695e17da9500f8333aaba57e9.jpg";